import React, { useState } from 'react'
import GameManager from '../../../../../GameManager';
import Tools from '../../../../../Misc/Tools';
import { JSXUIData, JSXUIDebugTemplate } from '../../../../../UI/JsxUiManager';
import { UI } from '../../../../../UI/UiManager';
import CoreGeneralButton from '../../core-general-button';
import CoreGeneralButton2, { AllButton2Types, GeneralButton2Type } from '../../core-general-button2';
import CoreGeneralButton3, { AllButton3Types, GeneralButton3Type } from '../../core-general-button3';
import * as ReactDOMServer from 'react-dom/server';
import "./core-debug-animations-window.css"
import CoreGeneralButton4, { AllButton4Types, GeneralButton4Type } from '../../core-general-button4';
import CoreAccordion from '../../core-accordion';
import CoreDebugSideMenu from './core-debug-dropdown-window';
import CoreBreadcrumbs from '../../core-breadcrumbs';
import CoreCards from '../../core-cards';
import CoreCarousel from '../../core-carousel';
import CoreBar, { CoreBarColorType } from '../../core-bar';
import CoreDropdown from '../../core-dropdown';
import CoreTooltip from '../../core-tooltip';
import CoreDatePicker from '../../core-date-picker';

enum ComponentsWindowType {
	None = "None",
	Accordion = "Accordion",
	Breadcrumbs = "Breadcrumbs",
	Cards = "Cards",
	Carousel = "Carousel",
	ProgressBar = "ProgressBar",
	ToastNotification = "ToastNotification",
	Dropdown = "Dropdown",
	Tooltip = "Tooltip",
	DatePicker = "Date Picker"
}

const allWindows = [
	ComponentsWindowType.Accordion,
	ComponentsWindowType.Breadcrumbs,
	ComponentsWindowType.Cards,
	ComponentsWindowType.Carousel,
	ComponentsWindowType.ProgressBar,
	ComponentsWindowType.ToastNotification,
	ComponentsWindowType.Dropdown,
	ComponentsWindowType.Tooltip,
	ComponentsWindowType.DatePicker
]

const CoreDebugComponentsWindow = (props: CoreDebugComponentsWindowConfig) => {
	const [componentsWindowType, setComponentsWindowType] = useState(ComponentsWindowType.None);
	const renderWindowTypeNone = () => {
		return (
			<div className='core-debug-ui-general-window' style={{ width: '900px', height: '900px', 'overflow': 'auto' }}>
				<div key={Tools.generateGuid()} style={{
					marginTop: '10px'
				}}>
					{allWindows.map((item: ComponentsWindowType, indx: number) => {
						return (
							<CoreGeneralButton width='100%'
								height='50px'
								onClick={() => {
									setComponentsWindowType(item);
								}}
								onRenderContent={() => {
									return (
										<p className='small-text center-element' style={{ textAlign: 'center' }}>{item}</p>
									)
								}}
								isSelected={false}
								isDisabled={false}
								ariaLabel={''}></CoreGeneralButton>
						)
					})}
				</div>

			</div>
		);
	};

	const renderWindowTypeAccordion = () => {
		const component = (<CoreAccordion firstExpandedItemIndex={0} items={[
			{
				title: 'Sample 1',
				description: 'Description 1'
			},
			{
				title: 'Sample 2',
				description: 'Description 2'
			}
		]} style={{
			accordion: (theme) => {
				return {
	  'background-color': 'gray' //example of injecting css
				}
			},
			accordionDetails: (theme) => {
				return {
				}
			},
			accordionSummary: (theme) => {
				return {
				}
			},
		}}></CoreAccordion>
)

		const componentAsString = 
			`
			<CoreAccordion firstExpandedItemIndex={0} items={[
				{
					title: 'Sample 1',
					description: 'Description 1'
				},
				{
					title: 'Sample 2',
					description: 'Description 2'
				}
			]} style={{
				accordion: (theme) => {
					return {
		  'background-color': 'gray' //example of injecting css
					}
				},
				accordionDetails: (theme) => {
					return {
					}
				},
				accordionSummary: (theme) => {
					return {
					}
				},
			}}
			`;
		return (
			<div>
				<div style={{
					position: 'absolute',
					top: '850px',
					left: '10px'
				}}>
					<CoreDebugSideMenu hideDropdown={true} codeSnippet={(componentAsString)}></CoreDebugSideMenu>
				</div>
				<div style={{
					width: '300px',
					height: '100px',
					position: 'absolute',
				}} className="center-element">
					{component}
				</div>
			</div>
		)
	};

	const renderWindowTypeBreadcrumbs = () => {
		const component = (<CoreBreadcrumbs pages={[
			{
				userFriendlyTitle: 'Home',
				url: ''
			},
			{
				userFriendlyTitle: 'Scenario 1',
				url: 'scenario1-piv-badge'
			},
			{
				userFriendlyTitle: 'Intro',
				url: 'scenario1-piv-badge'
			}
		]}></CoreBreadcrumbs>
)

		const componentAsString = 
			`
			<CoreBreadcrumbs pages={[
				{
					userFriendlyTitle: 'Home',
					url: ''
				},
				{
					userFriendlyTitle: 'Scenario 1',
					url: 'scenario1-piv-badge'
				},
				{
					userFriendlyTitle: 'Intro',
					url: 'scenario1-piv-badge'
				}
			]}></CoreBreadcrumbs>
			`;
		return (
			<div>
				<div style={{
					position: 'absolute',
					top: '850px',
					left: '10px'
				}}>
					<CoreDebugSideMenu hideDropdown={true} codeSnippet={(componentAsString)}></CoreDebugSideMenu>
				</div>
				<div style={{
					width: '590px',
					height: '100px',
					position: 'absolute',
				}} className="center-element">
					{component}
				</div>
			</div>
		)
	};

	const renderWindowTypeCards = () => {
		const component = (<CoreCards cards={[
			{
				img: process.env.PUBLIC_URL + '/assets/core/images/sample.jpg',
				htmlContent: `
			<p class="default-text">
				<strong>Lorem Ipsum</strong> is simply dummy text of the printing and 
				typesetting industry. Lorem Ipsum has been the 
				industry's standard dummy text ever since the 1500s,
				when an unknown printer took a galley of type and 
				scrambled it to make a type specimen book. It has 
				survived not only five centuries, but also the leap 
				into electronic typesetting, remaining essentially 
				unchanged. It was popularised in the 1960s with the 
				release of Letraset sheets containing Lorem Ipsum 
				passages, and more recently with desktop publishing
				software like Aldus PageMaker including versions of 
				Lorem Ipsum.
			</p>
			`
			},
			{
				img: process.env.PUBLIC_URL + '/assets/core/images/sample.jpg',
				htmlContent: `
			<p class="default-text">
				<strong>Lorem Ipsum</strong> is simply dummy text of the printing and 
				typesetting industry. Lorem Ipsum has been the 
				industry's standard dummy text ever since the 1500s,
				when an unknown printer took a galley of type and 
				scrambled it to make a type specimen book. It has 
				survived not only five centuries, but also the leap 
				into electronic typesetting, remaining essentially 
				unchanged. It was popularised in the 1960s with the 
				release of Letraset sheets containing Lorem Ipsum 
				passages, and more recently with desktop publishing
				software like Aldus PageMaker including versions of 
				Lorem Ipsum.
			</p>
			`
			}
		]}></CoreCards>
)

		const componentAsString = 
			`
			<CoreCards cards={[
				{
					img: process.env.PUBLIC_URL + '/assets/core/images/sample.jpg',
					htmlContent: \`
				<p class="default-text">
					<strong>Lorem Ipsum</strong> is simply dummy text of the printing and 
					typesetting industry. Lorem Ipsum has been the 
					industry's standard dummy text ever since the 1500s,
					when an unknown printer took a galley of type and 
					scrambled it to make a type specimen book. It has 
					survived not only five centuries, but also the leap 
					into electronic typesetting, remaining essentially 
					unchanged. It was popularised in the 1960s with the 
					release of Letraset sheets containing Lorem Ipsum 
					passages, and more recently with desktop publishing
					software like Aldus PageMaker including versions of 
					Lorem Ipsum.
				</p>
				\`
				},
				{
					img: process.env.PUBLIC_URL + '/assets/core/images/sample.jpg',
					htmlContent: \`
				<p class="default-text">
					<strong>Lorem Ipsum</strong> is simply dummy text of the printing and 
					typesetting industry. Lorem Ipsum has been the 
					industry's standard dummy text ever since the 1500s,
					when an unknown printer took a galley of type and 
					scrambled it to make a type specimen book. It has 
					survived not only five centuries, but also the leap 
					into electronic typesetting, remaining essentially 
					unchanged. It was popularised in the 1960s with the 
					release of Letraset sheets containing Lorem Ipsum 
					passages, and more recently with desktop publishing
					software like Aldus PageMaker including versions of 
					Lorem Ipsum.
				</p>
				\`
				}
			]}></CoreCards>
			`;
		return (
			<div>
				<div style={{
					position: 'absolute',
					top: '850px',
					left: '10px'
				}}>
					<CoreDebugSideMenu hideDropdown={true} codeSnippet={(componentAsString)}></CoreDebugSideMenu>
				</div>
				<div style={{
					width: '810px',
					position: 'absolute'
				}} className="center-element">
					{component}
				</div>
			</div>
		)
	};

	const renderWindowTypeCarousel = () => {
		const component = (<CoreCarousel cardsPerView={3} cards={[
			{
				img: process.env.PUBLIC_URL + '/assets/core/images/sample.jpg'
			},
			{
				img: process.env.PUBLIC_URL + '/assets/core/images/sample2.jpg'
			},
			{
				img: process.env.PUBLIC_URL + '/assets/core/images/sample3.jpg'
			},
			{
				img: process.env.PUBLIC_URL + '/assets/core/images/sample4.jpg'
			},
			{
				img: process.env.PUBLIC_URL + '/assets/core/images/sample5.jpg'
			},
			{
				img: process.env.PUBLIC_URL + '/assets/core/images/sample6.jpg'
			},
			{
				img: process.env.PUBLIC_URL + '/assets/core/images/sample7.jpg'
			}
		]}></CoreCarousel>
)

		const componentAsString = 
			`
			<CoreCarousel cardsPerView={3} cards={[
				{
					img: process.env.PUBLIC_URL + '/assets/core/images/sample.jpg'
				},
				{
					img: process.env.PUBLIC_URL + '/assets/core/images/sample2.jpg'
				},
				{
					img: process.env.PUBLIC_URL + '/assets/core/images/sample3.jpg'
				},
				{
					img: process.env.PUBLIC_URL + '/assets/core/images/sample4.jpg'
				},
				{
					img: process.env.PUBLIC_URL + '/assets/core/images/sample5.jpg'
				},
				{
					img: process.env.PUBLIC_URL + '/assets/core/images/sample6.jpg'
				},
				{
					img: process.env.PUBLIC_URL + '/assets/core/images/sample7.jpg'
				}
			]}></CoreCarousel>
			`;
		return (
			<div>
				<div style={{
					position: 'absolute',
					top: '850px',
					left: '10px'
				}}>
					<CoreDebugSideMenu hideDropdown={true} codeSnippet={(componentAsString)}></CoreDebugSideMenu>
				</div>
				<div style={{
					width: '1500px',
					height: '500px',
					position: 'absolute',
				}} className="center-element">
					{component}
				</div>
			</div>
		)
	};

	const renderWindowTypeProgressBar = () => {
		const component = (
			<CoreBar color={CoreBarColorType.blue} percentage={.75}></CoreBar>
)

		const componentAsString = 
			`
			<CoreBar color={CoreBarColorType.blue} percentage={.75}></CoreBar>
			`;
		return (
			<div> 
				<div style={{
					position: 'absolute',
					top: '850px',
					left: '10px'
				}}>
					<CoreDebugSideMenu hideDropdown={true} codeSnippet={(componentAsString)}></CoreDebugSideMenu>
				</div>
				<div style={{
					width: '300px',
					height: '50px',
					position: 'absolute',
				}} className="center-element">
					{component}
				</div>
			</div>
		)
	};

	const renderWindowTypeToastNotification = () => {
		const component = (
			<CoreGeneralButton width='100%'
					height='50px'
					onClick={() => {
						Tools.showToastNotification('This is a test notification');
					}}
					onRenderContent={() => {
						return (
							<p className='small-text center-element' style={{ textAlign: 'center' }}>{'Send Toast Notification'}</p>
						)
					}}
					isSelected={false}
					isDisabled={false}
					ariaLabel={''}></CoreGeneralButton>
)

		const componentAsString = 
			`
			Tools.showToastNotification('This is a test notification');
			`;
		return (
			<div> 
				<div style={{
					position: 'absolute',
					top: '850px',
					left: '10px'
				}}>
					<CoreDebugSideMenu hideDropdown={true} codeSnippet={(componentAsString)}></CoreDebugSideMenu>
				</div>
				<div style={{
					width: '300px',
					height: '50px',
					position: 'absolute',
				}} className="center-element">
					{component}
				</div>
			</div>
		)
	};

	const renderWindowTypeDropdown = () => {
		const component = (
			<CoreDropdown defaultSelectedIndex={0} placeholderText='Please select from list'
							items={[
								"Item 1",
								"Item 2",
								"Item 3"
							]}
							canSelectNothing={true}
							onItemSelected={(item: string | number, index: number) => {
								alert(item + ' selected (index ' + index + ')')
							}}></CoreDropdown>
)

		const componentAsString = 
			`
			<CoreDropdown defaultSelectedIndex={0} placeholderText='Please select from list'
							items={[
								"Item 1",
								"Item 2",
								"Item 3"
							]}
							canSelectNothing={true}
							onItemSelected={(item: string | number, index: number) => {
								alert(item + ' selected (index ' + index + ')')
							}}></CoreDropdown>
			`;
		return (
			<div> 
				<div style={{
					position: 'absolute',
					top: '850px',
					left: '10px'
				}}>
					<CoreDebugSideMenu hideDropdown={true} codeSnippet={(componentAsString)}></CoreDebugSideMenu>
				</div>
				<div style={{
					width: '300px',
					height: '50px',
					position: 'absolute',
				}} className="center-element">
					{component}
				</div>
			</div>
		)
	};

	const renderWindowTypeTooltip = () => {
		const component = (
			<div>
				<p id='sample-tooltip-element' className='default-text' style={{color: 'white', backgroundColor: 'black', cursor: 'pointer'}}>Hover over me!</p>
				<CoreTooltip hoverParentElementId='sample-tooltip-element' text='Sample Tooltip'></CoreTooltip>
			</div>
			
)

		const componentAsString = 
			`
			<div>
				<p id='sample-tooltip-element' className='default-text' style={{color: 'white', backgroundColor: 'black', cursor: 'pointer'}}>Hover over me!</p>
				<CoreTooltip hoverParentElementId='sample-tooltip-element' text='Sample Tooltip'></CoreTooltip>
			</div>

			`;
		return (
			<div> 
				<div style={{
					position: 'absolute',
					top: '850px',
					left: '10px'
				}}>
					<CoreDebugSideMenu hideDropdown={true} codeSnippet={(componentAsString)}></CoreDebugSideMenu>
				</div>
				<div style={{
					width: '300px',
					height: '50px',
					position: 'absolute',
				}} className="center-element">
					{component}
				</div>
			</div>
		)
	};

	const renderWindowTypeDatePicker = () => {
		const component = (
			<CoreDatePicker></CoreDatePicker>
			
)

		const componentAsString = 
			`
			<div>
				<p id='sample-tooltip-element' className='default-text' style={{color: 'white', backgroundColor: 'black', cursor: 'pointer'}}>Hover over me!</p>
				<CoreTooltip hoverParentElementId='sample-tooltip-element' text='Sample Tooltip'></CoreTooltip>
			</div>

			`;
		return (
			<div> 
				<div style={{
					position: 'absolute',
					top: '850px',
					left: '10px'
				}}>
					<CoreDebugSideMenu hideDropdown={true} codeSnippet={(componentAsString)}></CoreDebugSideMenu>
				</div>
				<div style={{
					width: '300px',
					position: 'absolute',
				}} className="center-element">
					{component}
				</div>
			</div>
		)
	};

	const renderWindow = () => {
		switch (componentsWindowType) {
			case ComponentsWindowType.None:
				return renderWindowTypeNone()
			case ComponentsWindowType.Accordion:
				return renderWindowTypeAccordion();
			case ComponentsWindowType.Breadcrumbs:
				return renderWindowTypeBreadcrumbs();
			case ComponentsWindowType.Cards:
				return renderWindowTypeCards();
			case ComponentsWindowType.Carousel:
				return renderWindowTypeCarousel();
			case ComponentsWindowType.ProgressBar:
				return renderWindowTypeProgressBar();
			case ComponentsWindowType.ToastNotification:
				return renderWindowTypeToastNotification();
			case ComponentsWindowType.Dropdown:
				return renderWindowTypeDropdown();
			case ComponentsWindowType.Tooltip:
				return renderWindowTypeTooltip();
			case ComponentsWindowType.DatePicker:
				return renderWindowTypeDatePicker();
		}
	};
	return (
		<div className='core-debug-ui-animations-window core-debug-ui-general-window'>
			<div className='core-debug-ui-back-bttn'>
				<CoreGeneralButton width='100%'
					height='100%'
					onClick={props.onBackToMainWindowClicked}
					onRenderContent={() => {
						return (
							<p className='small-text center-element'>{'Back to Main Window'}</p>
						)
					}}
					isSelected={false}
					isDisabled={false}
					ariaLabel={'Back to Main Window'}></CoreGeneralButton>
			</div>

			{renderWindow()}
		</div>
	);
}

export interface CoreDebugComponentsWindowConfig {
	showWindowBackground: boolean;
	gameManager: GameManager;
	onBackToMainWindowClicked: () => void;
	onTestEnvironmentSpawned: () => void;
	setForceUpdate: () => void;
}

export default CoreDebugComponentsWindow;
